import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface EvidenceSource {
  category?: string;
  source: string;
  confidence: number;
  url?: string;
  snippet?: string;
  type?: string;
  domain?: string;
}

@Component({
  selector: 'app-common-sources',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './common-sources.component.html',
  styleUrl: './common-sources.component.scss'
})
export class CommonSourcesComponent {
  @Input() evidenceSources: EvidenceSource[] = [];
  @Input() title: string = 'Data Sources & Evidence';
  @Input() showTitle: boolean = true;

  getEvidenceTooltip(evidence: EvidenceSource): string {
    if (!evidence) return '';

    let tooltip = '';
    if (evidence.category) tooltip += `Category: ${evidence.category}\n`;
    if (evidence.confidence && typeof evidence.confidence === 'number') {
      tooltip += `Confidence: ${Math.round(evidence.confidence * 100)}%\n`;
    }
    if (evidence.snippet) tooltip += `Snippet: ${evidence.snippet}\n`;
    if (evidence.url) tooltip += `\nClick to view source`;

    return tooltip.trim();
  }

  openSourceLink(url: string): void {
    if (url && url.trim() !== '' && url !== '#') {
      // Open the link in a new tab
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      // Show a message if no URL is available
      // console.log('No source URL available for this item');
    }
  }
}
